<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-2">How many oranges are needed to make 13 glasses of juice?</p>
      <p class="mb-4">
        <v-radio-group v-model="inputs.input1" :disabled="!allowEditing" class="mb-0 ml-3">
          <v-radio
            v-for="option in options1"
            :key="option.value"
            :value="option.value"
            class="my-3"
          >
            <template #label>
              <stemble-latex :content="option.text" />
            </template>
          </v-radio>
        </v-radio-group>
      </p>

      <h3><u>Reason</u></h3>
      <p class="mb-2">
        <v-radio-group v-model="inputs.input2" :disabled="!allowEditing" class="mb-0 ml-3">
          <v-radio
            v-for="option in options2"
            :key="option.value"
            :value="option.value"
            class="my-3"
          >
            <template #label>
              <stemble-latex :content="option.text" />
            </template>
          </v-radio>
        </v-radio-group>
      </p>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '../StembleLatex.vue';

export default {
  name: 'UPEIToTLItem2',
  components: {
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
        input2: null,
      },
      options1: [
        {text: '$6 \\frac{1}{2}$ oranges', value: 'a'},
        {text: '$8 \\frac{2}{3}$ oranges', value: 'b'},
        {text: '$9$ oranges', value: 'c'},
        {text: '$11$ oranges', value: 'd'},
        {text: 'Other', value: 'e'},
      ],
      options2: [
        {
          text: 'The number of glasses compared to the number of oranges will always be in ratio 2 to 3.',
          value: 'one',
        },
        {text: 'If there are seven more glasses, then five more oranges are needed.', value: 'two'},
        {
          text: 'The difference in the numbers will always be two.',
          value: 'three',
        },
        {
          text: 'The number of oranges will be half the number of glasses.',
          value: 'four',
        },
        {
          text: 'There is no way of predicting the number of oranges.',
          value: 'five',
        },
      ],
    };
  },
};
</script>
<style scoped></style>
